import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				height: "100%",
				alignItems: "center"
			},
			title: {
				fontSize: 15,
				marginTop: 15,
				color: theme.palette.grey[500]
			},
			btnSubmit: {
				background: theme.palette.grey["A100"],
				color: theme.palette.secondary.main,
				fontSize: 14,
				textTransform: "inherit",
				width: 167,
				height: 36,
				borderRadius: 6,
				border: `1px solid ${theme.palette.secondary.main}`,
				marginTop: 40,
				"&:hover": {
					background: `${theme.palette.secondary.dark} !important`
				}
			}
		}),
	{
		name: "ErrorPage",
		index: 1
	}
);

export default useStyles;
